const CONTEXT_FILTER_PARAMS = new Set(['view', 'tab', 'source', 'idents']);

export function isActiveFilterValue(value: unknown): boolean {
  if (value === undefined || value === null || value === '') return false;
  if (Array.isArray(value) && value.length === 0) return false;
  return true;
}

export function isActiveFilter(filter: { value?: unknown; emptiness?: string }): boolean {
  return isActiveFilterValue(filter.value) || Boolean(filter.emptiness);
}

export function getActiveColumnFilters(
  filters: Array<{ name: string; value?: unknown; emptiness?: string }> = [],
) {
  return filters.filter(f => !CONTEXT_FILTER_PARAMS.has(f.name) && isActiveFilter(f));
}

export function hasActiveColumnFilters(
  filters: Array<{ name: string; value?: unknown; emptiness?: string }> = [],
): boolean {
  return getActiveColumnFilters(filters).length > 0;
}
